<section class="invalid-link" role="main">
  <div class="invalid-link__card">
    <nova-icon name="warning_amber" size="medium" [ariaHidden]="true" />
    <h1>{{ 'invalid-link.TITLE' | translate }}</h1>
    <p>{{ 'invalid-link.MESSAGE' | translate }}</p>
    <p class="invalid-link__hint">{{ 'invalid-link.HINT' | translate }}</p>
    <a
      class="nova-link"
      href="tel:+18449131386"
      [attr.aria-label]="'invalid-link.CALL_SUPPORT' | translate"
    >{{ phoneNumber }}</a>
  </div>
</section>
